import createCanAccess from './createCanAccess';
import { getStore } from '../redux/store';

const canAccess = createCanAccess(getStore());

export default canAccess;